import { isDateOnly } from './date-only';

export type LandingCardPolicy = 'accepted' | 'conditional' | 'not_sufficient' | 'unknown';
export type EntryEligibility = 'NOT_REQUIRED' | 'VISA' | 'LANDING_CARD' | 'LANDING_CARD_CONDITIONAL' | 'NOT_ELIGIBLE' | 'UNKNOWN';
export interface LandingCardDeclaration {
  hasLandingCard: boolean;
  landingCardExpiryDate: string | null;
}
export const LANDING_CARD_NOTICE = 'Landing Card / UMB, ülke ve görev koşullarına bağlı olarak personelin görev amaçlı girişinde kullanılabilir. Normal vize yerine geçtiği varsayılmaz.';
export const ENTRY_VERIFICATION_NOTICE = 'Nihai giriş şartları görev öncesinde ilgili ülke kurallarına göre doğrulanmalıdır.';

export function landingCardPolicy(countryCode: string, isSchengen: boolean): {
  policy: LandingCardPolicy; note: string; source: string | null; lastVerifiedAt: string | null;
} {
  if (isSchengen) return {
    policy: 'conditional', note: 'Görev, mürettebat statüsü ve izin verilen giriş alanı doğrulanmalı.',
    source: 'https://eur-lex.europa.eu/legal-content/EN/TXT/?uri=CELEX:32016R0399', lastVerifiedAt: '2026-09-17',
  };
  if (countryCode === 'RU') return {
    policy: 'conditional', note: 'Başlangıç planlama politikası: General Declaration, mürettebat kapsamı ve teknik personelin giriş şartları ayrıca doğrulanmalı.',
    source: null, lastVerifiedAt: null,
  };
  if (countryCode === 'GB' || countryCode === 'US') return {
    policy: 'not_sufficient', note: 'Landing Card tek başına yeterli değildir; normal giriş şartları devam eder.',
    source: countryCode === 'GB' ? 'https://www.gov.uk/government/publications/aircrew/aircrew-accessible' : 'https://travel.state.gov/content/travel/en/us-visas/other-visa-categories/crewmember-visa.html',
    lastVerifiedAt: '2026-09-17',
  };
  return { policy: 'unknown', note: 'Ülke şartları doğrulanmalı.', source: null, lastVerifiedAt: null };
}

export function hasValidLandingCard(card: Partial<LandingCardDeclaration>, date: string) {
  return card.hasLandingCard === true && (!card.landingCardExpiryDate
    || (isDateOnly(card.landingCardExpiryDate) && card.landingCardExpiryDate >= date));
}

export function entryEligibility(input: { domestic: boolean; validVisa: boolean; validLandingCard: boolean; policy: LandingCardPolicy }): EntryEligibility {
  if (input.domestic) return 'NOT_REQUIRED';
  if (input.validVisa) return 'VISA';
  if (!input.validLandingCard) return 'NOT_ELIGIBLE';
  if (input.policy === 'accepted') return 'LANDING_CARD';
  if (input.policy === 'conditional') return 'LANDING_CARD_CONDITIONAL';
  return input.policy === 'unknown' ? 'UNKNOWN' : 'NOT_ELIGIBLE';
}

export function entryEligibilityLabel(status: EntryEligibility) {
  return ({ NOT_REQUIRED: 'Yurt içi görev', VISA: 'Vize uygun', LANDING_CARD: 'Landing Card ile görev girişi',
    LANDING_CARD_CONDITIONAL: 'Landing Card ile görev girişi — şartları kontrol et',
    NOT_ELIGIBLE: 'Uygun vize bulunamadı', UNKNOWN: 'Landing Card mevcut – ülke şartı doğrulanmalı' })[status];
}

export function landingCardLabel(card: Partial<LandingCardDeclaration>, date: string) {
  if (!card.hasLandingCard) return 'Landing Card / UMB: Yok';
  if (!hasValidLandingCard(card, date)) return 'Landing Card süresi dolmuş';
  return `Landing Card ✓${card.landingCardExpiryDate ? ` · ${card.landingCardExpiryDate.slice(5, 7)}/${card.landingCardExpiryDate.slice(0, 4)}` : ''}`;
}
